import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { fetchCampaignSearchFilters } from '~/services/campaign';

interface StatusOption {
    value: string;
    label: string;
}

const MedProsNeedingEmailAccordionItem: React.FC = () => {
    const navigate = useNavigate();
    const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
    const [selected, setSelected] = useState<StatusOption | null>(null);

    useEffect(() => {
        fetchCampaignSearchFilters()
            .then((d) =>
                setStatusOptions(
                    d.campaign_statuses.map((s: any) => ({
                        value: s.code,
                        label: s.name,
                    })),
                ),
            )
            .catch(() => setStatusOptions([]));
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const params = new URLSearchParams();
        if (selected) params.set('campaign_status', selected.value);
        navigate(
            `/reports/predefined/med-pros-needing-email/results?${params.toString()}`,
        );
    };

    return (
        <div className='flex h-full w-full flex-col rounded-sm border border-stroke bg-white px-7.5 py-5 shadow-default'>
            <h4 className='text-title-xsm font-bold sm:text-title-md'>
                Medical Professionals Needing Email
            </h4>
            <p className='mt-2 text-sm text-body'>
                Patient campaigns whose assigned medical professional has no
                email on file.
            </p>
            <form onSubmit={handleSubmit} className='mt-4 flex flex-1 flex-col'>
                <div>
                    <label className='mb-1 block text-[12px] font-bold'>
                        Campaign Status
                    </label>
                    <Select
                        menuPlacement='auto'
                        options={statusOptions}
                        isClearable
                        value={selected}
                        onChange={(opt) =>
                            setSelected(opt as StatusOption | null)
                        }
                        placeholder='Any Status'
                        styles={{
                            control: (base) => ({ ...base, minHeight: '40px' }),
                        }}
                    />
                </div>
                <div className='mt-auto pt-6'>
                    <button
                        type='submit'
                        className='rounded-lg bg-primary px-8 py-3 text-sm font-medium text-white'
                    >
                        Run report
                    </button>
                </div>
            </form>
        </div>
    );
};

export default MedProsNeedingEmailAccordionItem;
